import * as THREE from 'three'
import Experience from "../Experience";
import Buildings from './assets/Buildings.js';
import Road from './assets/Road.js';
import vertexBody from '../../shaders/building/body/vertex.glsl'
import fragmentBody from '../../shaders/building/body/fragment.glsl'
import vertexVitre from '../../shaders/building/vitre/vertex.glsl'
import fragmentVitre from '../../shaders/building/vitre/fragment.glsl'
import vertexRoad from '../../shaders/road/vertex.glsl'
import fragmentRoad from '../../shaders/road/fragment.glsl'
import Soul from './assets/Soul.js';


export default class Tableau2 {
    constructor(_options) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.ressources = this.experience.ressources
        this.time = this.experience.time
        // 
        this.isDestroyed = false
        this.targetPos = new THREE.Vector3(0, 0, 0)
        // 
        this.setMaterials()

        this.batiments = new Buildings({
            targetPos: this.targetPos,
            materials: this.materials
        })
        this.road = new Road({
            targetPos: this.targetPos,
            materials: this.materials

        })
        this.setSoul()
        this.setDebug()



    }
    setMaterials() {

        // this.vitreMaterialblack = new THREE.MeshBasicMaterial({ color: 'black' })
        this.vitreMaterialblack = new THREE.ShaderMaterial({
            vertexShader: vertexVitre,
            fragmentShader: fragmentVitre,
            transparent: true,
            uniforms: {
                u_power: new THREE.Uniform(0),
                u_fog: new THREE.Uniform(0.8)
            }
        })
        // this.vitreMaterialwhite = new THREE.MeshBasicMaterial({ color: 'white' })
        this.vitreMaterialwhite = new THREE.ShaderMaterial({
            vertexShader: vertexVitre,
            fragmentShader: fragmentVitre,
            transparent: true,
            uniforms: {
                u_power: new THREE.Uniform(2),
                u_fog: new THREE.Uniform(0.8)
            }
        })
        this.bodyMaterial = new THREE.ShaderMaterial({
            vertexShader: vertexBody,
            fragmentShader: fragmentBody,
            transparent: true,
            uniforms: {
                u_fog: new THREE.Uniform(0.8)
                // u_fog: new THREE.Uniform(1.5)
            }
        })
        this.roadMaterial = new THREE.ShaderMaterial({
            vertexShader: vertexRoad,
            fragmentShader: fragmentRoad,
            transparent: true,
            uniforms: {
                u_fog: new THREE.Uniform(1.83),
                u_targetPos: new THREE.Uniform(new THREE.Vector3(0, 0, 0))
            }
        })

        this.materials = {
            road: this.roadMaterial,
            body: this.bodyMaterial,
            white: this.vitreMaterialwhite,
            black: this.vitreMaterialblack,
        }

    }
    setSoul() {
        if (this.experience.debug.active) {
            const ui = this.experience.debug.ui
            this.soulFolder = ui.addFolder('main soul')
        }

        this.soul = new Soul({
            position: new THREE.Vector3(this.targetPos.x, 1.5, 0),
            debugFolder: this.soulFolder,
        })
        this.soul.mesh.scale.set(0.3, 0.3, 0.3)
        this.soul.material.uniforms.u_gotIdea.value = 1.5
        this.soulRandom = Math.random()

        // Stocker l'ID du setInterval
        this.soulInterval = setInterval(() => {
            this.soul.setEmotion(this.soulRandom < 0.5 ? 'sad' : 'round')
            this.soulRandom = Math.random()
        }, 3000 + (this.soulRandom * 1000));
    }




    setDebug() {
        if (this.experience.debug.active) {
            const ui = this.experience.debug.ui
            const buildingsFolder = ui.addFolder('buildings')
            buildingsFolder.add(this.bodyMaterial.uniforms.u_fog, 'value').min(-1).max(5).step(0.001).onChange((value) => {
                this.bodyMaterial.uniforms.u_fog.value = value
                this.vitreMaterialwhite.uniforms.u_fog.value = value
                this.vitreMaterialblack.uniforms.u_fog.value = value
                this.roadMaterial.uniforms.u_fog.value = value
            })

        }
    }
    destroy() {
        // Supprimer les sous-composants s'ils ont une méthode destroy()
        this.batiments?.destroy?.()
        this.road?.destroy?.()
        this.soul?.destroy?.()

        // Nettoyer les matériaux
        Object.values(this.materials).forEach(mat => {
            if (mat.dispose) mat.dispose()
        })

        // Supprimer le mesh de la soul de la scène si présent
        if (this.soul?.mesh) {
            this.scene.remove(this.soul.mesh)
            this.soul.mesh.geometry?.dispose?.()
            this.soul.mesh.material?.dispose?.()
        }
        if (this.soulInterval) {
            clearInterval(this.soulInterval)
        }


        // Supprimer les références
        this.batiments = null
        this.road = null
        this.soul = null
        this.materials = null
        this.scene = null
        this.ressources = null
        this.experience = null
        this.targetPos = null
        this.time = null
        // 
        this.isDestroyed = true

    }


    updateCamera() {
        if (!this.isDestroyed) {
            this.experience.camera.instance.position.x = this.batiments.targetPos.x + 3 + Math.cos(this.time.elapsed * 0.0005)
            this.experience.camera.instance.position.z = 7 - Math.cos(this.time.elapsed * 0.0005)
            this.experience.camera.instance.position.y = Math.cos(this.time.elapsed * 0.0005) + 2

            this.experience.camera.instance.lookAt(new THREE.Vector3(this.batiments.targetPos.x + 2, 0, 1))
        }

    }

    update() {
        if (this.targetPos) {
            this.targetPos.x = this.time.elapsed * 0.001;
        }
        if (this.batiments) {
            this.batiments.update()

        }
        if (this.road) {
            this.road.update()

        }
        if (this.soul) {
            this.soul.position.set(this.targetPos.x, -1.25, 0.3)
            this.soul.update()

        }
        this.updateCamera()

    }
}